import classNames from 'classnames';
import RichText from '@/components/atoms/rich-text/rich-text';
import Typography from '@/components/atoms/typography/typography';
import CtaLinkList, {
  CtaLinkListProps,
} from '@/components/organisms/cta-link-list/cta-link-list';
import Column from '@/components/utilities/column/column';
import Container from '@/components/utilities/container/container';
import Row from '@/components/utilities/row/row';
import styles from './fact-box-block.module.scss';

export interface FactBoxBlockProps {
  /** The class name to apply */
  className?: string;
  /** An array of links to show */
  ctaLinks?: CtaLinkListProps['items'];
  /** The text to show as a headline */
  headline?: string | null;
  /** The rich text to show as a description */
  text?: string | null;
}

const FactBoxBlock = ({
  className,
  ctaLinks = [],
  headline,
  text,
}: FactBoxBlockProps) => {
  return (
    <div className={classNames(styles.component, className)}>
      <Container>
        <Row>
          <Column
            className={styles.column}
            offset={{ laptop: 2 }}
            width={{ laptop: 8 }}
          >
            <div className={styles.box}>
              {headline && (
                <Typography
                  className={styles.headline}
                  tag="h3"
                  tagStyle="bodyLargeBold"
                >
                  {headline}
                </Typography>
              )}

              {text && <RichText className={styles.text} text={text} />}

              {ctaLinks.length > 0 && (
                <CtaLinkList isHighlightSection items={ctaLinks} />
              )}
            </div>
          </Column>
        </Row>
      </Container>
    </div>
  );
};

FactBoxBlock.displayName = 'FactBoxBlock';

export default FactBoxBlock;
